import { Component, Input, ViewChild } from '@angular/core';
import { DwLayoutBase, DwSecurityState, DwUiConfigPanelComponent } from '@devwareapps/devware-cap';
import { StreakersOfflineStateComponent, StreakersSecurityStateComponent, StreakersUpdateNoticeComponent } from './streakers-state.components';

@Component({
  selector: 'streakers-layout',
  templateUrl: './streakers-layout.component.html',
  styleUrls: ['./streakers-layout.component.scss'],
})
export class StreakersLayoutComponent extends DwLayoutBase {
  @Input() environmentMessage: string;
  @ViewChild('configurationPanel') configurationPanel: DwUiConfigPanelComponent;
  private securityUpdateTimer: ReturnType<typeof setTimeout>;

  protected configureComponents(): void {
    super.configureComponents();
    this.components = {
      ...this.components,
      offlineComponent: StreakersOfflineStateComponent,
      securityMessageComponent: StreakersSecurityStateComponent,
      autoUpdateCheckerComponent: StreakersUpdateNoticeComponent,
    };
  }

  protected handleSecurityChange(state: DwSecurityState): void {
    // Security child initialization can emit while the shell is being checked.
    // Coalesce updates and preserve CAP handling outside that render pass.
    clearTimeout(this.securityUpdateTimer);
    this.securityUpdateTimer = setTimeout(() => {
      this.securityUpdateTimer = null;
      super.handleSecurityChange(state);
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.securityUpdateTimer);
    // CAP uses a body class for panel visibility; close it before switching shells.
    this.configurationPanel?.toggleSidebar('config', true);
    super.ngOnDestroy();
  }
}
